import * as React from 'react';
import classNames from 'classnames';
import style from './dialog.scss';

export type DialogPosition = (
  'topRight' |
  'topLeft' |
  'rightTop' |
  'rightBottom' |
  'bottomLeft' |
  'bottomRight' |
  'leftTop' |
  'leftBottom'
);

type DivElementProps = JSX.IntrinsicElements['div'];

export interface DialogProps extends DivElementProps {
  position: DialogPosition;
  component?: string | React.ComponentClass;
  triangleSize?: string;
  triangleOffset?: string;
  backgroundColor?: string;
}

export function Dialog({
  position = 'topLeft',
  component = 'div',
  className,
  children,
  style: propsStyle = {},
  triangleSize,
  triangleOffset,
  backgroundColor,
  ...restProps
}: DialogProps) {
  const Component = component;

  const customPropertyStyle = Object.assign({}, propsStyle);
  if (triangleSize) { customPropertyStyle['--triangle'] = triangleSize; }
  if (triangleOffset) { customPropertyStyle['--triangle-offset'] = triangleOffset; }
  if (backgroundColor) { customPropertyStyle['--triangle-color'] = backgroundColor; }

  return (
    <Component
      style={customPropertyStyle}
      className={classNames(style.dialog, className, style[position])}
      {...restProps}
    >{children}</Component>
  );
}

export default Dialog;
